import React from "react";

export default function InputFieldFloat({
  name,
  label,
  type,
  disabled,
  marginBottom,
  value,
  onChange,
  error,
  touched,
  containerClassName,
  direction,
  floating = false,
  placeholder = "",
  required = false,
  onBlur
}) {
  return (
    <div className={`input-text ${floating ? "floating-label" : ""}`}>
      <div
        className={`did-floating-label-content ${
          containerClassName ? containerClassName : ""
        }`}
        style={{ marginBottom: marginBottom ? marginBottom + "px" : "27px" }}
      >
        <input
          name={name}
          className="did-floating-input"
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          min={type === "number" ? 0 : undefined}
          style={{ direction: direction }}
        />
        <label className="did-floating-label">{label}{" "}{required && <span className="asterisk">*</span>}</label>
        {error && touched ? <div className="input-error">{error}</div> : null}
      </div>
    </div>
  );
}
